<template>
  <component-wrapper
    :attribute="attribute"
    :attributeName="attributeName"
    :complete-required="completeRequired"
    :data-cy="`${entityName}__textField--${attributeName}Container`"
    :entityName="entityName"
    :helpText="helpText"
    :id="id"
    :label="label"
    :shouldRender="shouldRender"
    :required="!!required"
    :showHeader="showHeader"
  >
    <v-text-field
      :counter="counter"
      :data-cy="`${entityName}__textField--${attributeName}`"
      :disabled="disabled"
      :filled="styleMap.filled"
      :outlined="styleMap.outlined"
      :placeholder="placeholder"
      :rules="validatorList"
      :solo="styleMap.solo"
      clearable
      required
      v-model="value"
    ></v-text-field>
  </component-wrapper>
</template>

<script>
import { keyBy } from "lodash";
import { mapGetters } from "vuex";

import { validatePrefixFactory, validateUniqueFactory } from "@/lib/validate";

import { resolveFk } from "@/lib/resolver";

import ComponentWrapper from "./ComponentWrapper";
import userInputMixin from "./userInputMixin";

export default {
  components: {
    ComponentWrapper,
  },
  computed: {
    attributeList() {
      const { entityName } = this;

      return this.filterAttributeList({ entityName });
    },
    list() {
      return this.$store.state[this.entityName].list;
    },
    ...mapGetters({
      filterAttributeList: "attribute/filter",
    }),
  },
  async created() {
    await this.configureValidatorListDecorator();
  },
  methods: {
    async configureValidatorListDecorator() {
      const {
        attributeList,
        attributeName,
        entity,
        entityName,
        idAttributeName,
        list: entityList,
      } = this;

      const { [idAttributeName]: id, locationId } = entity;

      if (!locationId) {
        return;
      }

      this.validatorList = [];

      this.validatorList.push(
        validateUniqueFactory({
          attributeName,
          entityList,
          entityName,
          id,
          idAttributeName,
        })
      );

      const attributeMap = keyBy(attributeList, "name");
      const { locationId: locationIdAttribute } = attributeMap;

      const location = await resolveFk(locationId, locationIdAttribute);
      const { locationNumber } = location;

      const validatePrefix = validatePrefixFactory(locationNumber);
      this.validatorList.push(validatePrefix);

      await this.configureValidatorList();
    },
  },
  mixins: [userInputMixin],
  props: {
    ruleList: {
      default: () => [],
      type: Array,
    },
  },
  watch: {
    async "entity.locationId"(newValue) {
      if (newValue) {
        try {
          await this.configureValidatorListDecorator();
        } catch (e) {
          this.$notifyError({
            message: "Error rendering Department Number input",
          });
          throw e;
        }
        this.$emit("validate");
      }
    },
  },
};
</script>
